import React, { Component } from 'react';
import { Table, Row, InputNumber, Button, DatePicker, message, Spin, Select } from 'antd';
import moment from 'moment';
import './index.scss';
import imgSave from "../../saveImg";
import { data2_1 } from './data';
import Auth from "../../Auth";
import Compared from "../../Compared";
import FileSaver from "file-saver";
import _ from "lodash";
import compute, { saveAllData } from './compute'

const { MonthPicker } = DatePicker;
const Option = Select.Option;

const TOTALINDEX = [32, 35, 40, 45, 51, 54, 55, 61, 70];

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            dataSelect: []
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }



    computeNum = (data) => {
        const { date } = this.state
        data = compute({ data, date });
        // 计算三
        this.setState({
            data,

        });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const year = moment(date).format('YYYY');
        const dataDefault = year >= 2022 ? _.cloneDeep(data2_1) : _.cloneDeep(data2_1).slice(0, 33);
        let data = dataDefault.filter((x, i) => i != 0);
        let dataSelect = dataDefault.filter((x, i) => i == 0);
        fetch(`/_2_1_all?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data2_1 && x.data.data2_1.length > 0) {
                data = x.data.data2_1.filter((x, i) => i != 0);
                dataSelect = x.data.data2_1.filter((x, i) => i == 0);
            } else if (x.data.dataLastMonth && x.data.dataLastMonth.length > 0) {
                // 获取当前月份之前所有的月份的实际数据
                let len = Number(moment(date).format('M') || "0") - 1;
                let name = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

                let newData = x.data.dataLastMonth.filter((x, index) => index != 0);
                // 自动填充淡旺季
                dataSelect = x.data.dataLastMonth.filter((x, i) => i == 0).map(x => { delete x.id; return x });
                if (newData && newData.length > 0) {
                    for (let i = 0; i < name.length; i++) {
                        if (i != len) {
                            data = data.map((z, index) => ({ ...z, [name[i]]: z[name[i]] != 0 ? z[name[i]] : _.get(newData, `${index}.${name[i]}`, 0) }));
                        }
                    }
                }
            }

            this.setState({ loading: false, dataSelect });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = [...this.state.dataSelect.map(x => ({ ...x, year, month })), ...this.state.data.map(x => ({ ...x, year, month }))];
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_2_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }


    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table2_1', 1.5, '2.10', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `Current Year P&L Analysis (Whole Year Forecast = Actual + Forecast) 本年损益分析（全年预测 = 实际+预测）${moment(this.state.date).format('YYYY-MM')}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }

    onFillLastMonth = () => {
        const _data = this.state.data;
        const _dataSelect = this.state.dataSelect;
        const date = this.state.date;
        this.setState({ loading: true, data: [] });
        const dataBegin = JSON.stringify(data2_1);
        let data = JSON.parse(dataBegin).filter((x, i) => i != 0);
        let dataSelect = JSON.parse(dataBegin).filter((x, i) => i == 0);
        fetch(`/_2_1_all?year=${moment(date).format('YYYY')}&month=${moment(date).subtract(1, 'month').format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data2_1 && x.data.data2_1.length > 0) {
                data = x.data.data2_1.filter((x, i) => i != 0).map((v, i) => {
                    delete v.id;
                    if (v.name == _.get(_data, `${i}.name`) && _.get(_data, `${i}.id`)) v.id = _.get(_data, `${i}.id`);
                    return v
                });
                dataSelect = x.data.data2_1.filter((x, i) => i == 0).map((v, i) => {
                    delete v.id;
                    if (v.name == _.get(_dataSelect, `${i}.name`) && _.get(_dataSelect, `${i}.id`)) v.id = _.get(_dataSelect, `${i}.id`);
                    return v
                });
            }
            console.log(data);
            this.setState({ loading: false, dataSelect });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }
    render() {
        const { data, dataSelect, print, date, loading } = this.state;
        const width = document.body.offsetWidth > 3825 ? document.body.offsetWidth - 3400 : 425;
        const inputIndex = [0, 1, 5, 6, 7, 9, 11, 13, 15, 17, 21, 24, 25, 26, 28, 29, 30, 31, 33, 36, 37, 38, 43, 41, 42, 46, 47, 48, 52, 56, 57, 58, 59, 62, 63, 64, 65, 69, 71, 72];
        const percentData = [2, 10, 12, 14, 16, 18, 20, 22];
        const totalData = [8, 22, 23, 27];
        let totalWidth = 3825;
        let columns = [
            // {
            //     title: 'key',
            //     width: 30,
            //     fixed: print ? false : "left",
            //     dataIndex: 'key',
            //     key: 'key',
            //     render: (text, record, index) => {
            //         return (
            //             <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
            //                 {index}
            //             </div>
            //         )
            //     }
            // },
            {
                align: "center",
                title: <div>P&L Index <br />  损益指数</div>,
                fixed: !print && "left",
                dataIndex: 'name',
                key: 'name',
                width,
                render: (text, record, index) => {
                    if (TOTALINDEX.includes(index)) {
                        return {
                            children: <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}
                                dangerouslySetInnerHTML={{ __html: text || "-" }}
                            ></div >,
                            props: {
                                colSpan: moment(date).format('M') == 12 ? 18 : 14
                            }
                        }
                    }
                    return (
                        <div
                            className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}
                            dangerouslySetInnerHTML={{ __html: text || "-" }}
                            style={{ textAlign: "left" }}></div >
                    )
                }
            }, {
                title: 'Jan 一月',
                align: "center",
                width: 200,
                children: [{
                    title: 1 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Jan || "1").toFixed(0).toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Jan = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Jan',
                        key: 'Jan',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Jan 一月-${1 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Jan', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Jan', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared>
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Jan', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared>
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Feb 二月',
                align: "center",
                width: 200,
                children: [{
                    title: 2 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Feb || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Feb = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Feb',
                        key: 'Feb',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Feb 二月-${2 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Feb', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Feb', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared>
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Feb', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared>
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Mar 三月',
                align: "center",
                width: 200,
                children: [{
                    title: 3 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Mar || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Mar = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Mar',
                        key: 'Mar',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Mar 三月-${3 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Mar', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Mar', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared>
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Mar', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared>
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Apr 四月',
                align: "center",
                width: 200,
                children: [{
                    title: 4 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Apr || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Apr = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Apr',
                        key: 'Apr',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Apr 四月-${4 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Apr', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Apr', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared>
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Apr', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared>
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'May 五月',
                align: "center",
                width: 200,
                children: [{
                    title: 5 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].May || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].May = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'May',
                        key: 'May',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`May 五月-${5 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'May', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('May', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared>
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'May', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Jun 六月',
                align: "center",
                width: 200,
                children: [{
                    title: 6 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Jun || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Jun = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Jun',
                        key: 'Jun',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Jun 六月-${6 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Jun', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Jun', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Jun', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Jul 七月',
                align: "center",
                width: 200,
                children: [{
                    title: 7 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Jul || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Jul = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Jul',
                        key: 'Jul',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Jul 七月-${7 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Jul', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Jul', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Jul', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Aug 八月',
                align: "center",
                width: 200,
                children: [{
                    title: 8 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Aug || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Aug = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Aug',
                        key: 'Aug',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Aug 八月-${8 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Aug', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Aug', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Aug', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Sep 九月',
                align: "center",
                width: 200,
                children: [{
                    title: 9 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Sep || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Sep = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Sep',
                        key: 'Sep',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Sep 九月-${9 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Sep', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Sep', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Sep', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Oct 十月',
                align: "center",
                width: 200,
                children: [{
                    title: 10 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Oct || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Oct = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Oct',
                        key: 'Oct',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Oct 十月-${10 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Oct', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Oct', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Oct', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Nov 十一月',
                align: "center",
                width: 200,
                children: [{
                    title: 11 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Nov || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Nov = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Nov',
                        key: 'Nov',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Nov 十一月-${11 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Nov', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Nov', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Nov', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: 'Dec 十二月',
                align: "center",
                width: 200,
                children: [{
                    title: 12 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测",
                    align: "center",
                    width: 200,
                    children: [{
                        title: <Select
                            value={dataSelect[0] ? Number(dataSelect[0].Dec || "1").toFixed(0).toString() : "1"}
                            onChange={(value) => {
                                let dataS = this.state.dataSelect;
                                dataS[0].Dec = value || "";
                                this.setState({ dataSelect: dataS });
                            }}
                        >
                            <Option value='1'>High旺季</Option>
                            <Option value='2'>Shoulder平季</Option>
                            <Option value='3'>Low淡季</Option>
                        </Select>,
                        align: "center",
                        width: 200,
                        dataIndex: 'Dec',
                        key: 'Dec',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Dec 十二月-${12 <= moment(this.state.date).format('M') ? "Actual实际" : "Forecast预测"}`];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'Dec', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('Dec', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'Dec', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }]
                }]
            }, {
                title: <div>Whole Year Forecast <br /> 全年预测</div>,
                align: "center",
                width: 200,
                dataIndex: 'whole',
                key: 'whole',
                render: (text, record, index) => {
                    if (TOTALINDEX.includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            }
                        }
                    }
                    const title = [`Whole Year Forecast 全年预测`];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index: index + 1, key: 'whole', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Variance - Next Year Forecast Vs. Budget </div>,
                width: 200,
                children: [{
                    title: 'Jan 一月',
                    width: 200,
                    children: [{
                        title: 'Forecast 预测',
                        width: 200,
                        align: "center",
                        dataIndex: 'nextJan',
                        key: 'nextJan',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Variance - Next Year Forecast Vs. Budget`, 'Jan 一月-Forecast 预测'];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'nextJan', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('nextJan', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'nextJan', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }],
                }, {
                    title: 'Feb 二月',
                    width: 200,
                    children: [{
                        title: 'Forecast 预测',
                        width: 200,
                        align: "center",
                        dataIndex: 'nextFeb',
                        key: 'nextFeb',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Variance - Next Year Forecast Vs. Budget`, 'Jan 二月-Forecast 预测'];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'nextFeb', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('nextFeb', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'nextFeb', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }],
                }, {
                    title: 'Mar 三月',
                    width: 200,
                    children: [{
                        title: 'Forecast 预测',
                        width: 200,
                        align: "center",
                        dataIndex: 'nextMar',
                        key: 'nextMar',
                        render: (text, record, index) => {
                            if (TOTALINDEX.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0
                                    }
                                }
                            }
                            const title = [`Variance - Next Year Forecast Vs. Budget`, 'Jan 三月-Forecast 预测'];
                            if (inputIndex.includes(index) && !print) {
                                return (
                                    <Compared data={{ index: index + 1, key: 'nextMar', title, sqlName: "_2_1", name: record.name, type: 'number' }}>
                                        <div className="table-color table-color-number">
                                            <InputNumber
                                                className="input-width"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={2}
                                                defaultValue={Number(text || "0") || ''}
                                                onBlur={(e) => {
                                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                    value = Number(value.toFixed(2));
                                                    this.onChange('nextMar', value, index)
                                                }}
                                            />
                                        </div>
                                    </Compared >
                                )
                            } else {
                                let html = null;
                                if (percentData.includes(index)) {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                                    }
                                } else {
                                    if (Number(text || "0") >= 0) {
                                        html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                                    } else {
                                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                                    }
                                }
                                return (
                                    <Compared data={{ index: index + 1, key: 'nextMar', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                            {html}
                                        </div>
                                    </Compared >
                                )
                            }
                        }
                    }],
                }, {
                    title: 'Q1 第一季度',
                    width: 200,
                    align: "center",
                    dataIndex: 'nextQ1',
                    key: 'nextQ1',
                    render: (text, record, index) => {
                        if (TOTALINDEX.includes(index)) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        const title = ['Q1 第一季度'];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'nextQ1', title, sqlName: "_2_1", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }];
        if (moment(date).format("M") < 10) {
            columns = columns.slice(0, columns.length - 1);
            totalWidth = 3025;
        }
        return (
            <Spin spinning={this.state.loading} >
                <div className="table table2_1">
                    <Row className="title" style={{ width: print ? 3875 : 'auto' }} id="table2_1">
                        <Row>2.1 Current Year P&L Analysis (Whole Year Forecast = Actual + Forecast) 本年损益分析（全年预测 = 实际+预测）</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                            <Button
                                type="primary"
                                style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                onClick={this.onFillLastMonth}
                            >填充上月数据</Button>
                            <Auth isAdmin={true}>
                                <Button
                                    type="primary"
                                    loading={loading}
                                    style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.setState({ loading: true }, async () => {
                                            await saveAllData(date);
                                            this.setState({ loading: false });
                                        })
                                    }}
                                >
                                    保存所有酒店数据
                                </Button>
                            </Auth>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            id="table"
                            className="content"
                            bordered
                            pagination={false}
                            style={{ width: print ? totalWidth : 'auto' }}
                            scroll={print ? {} : { x: totalWidth, y: 550 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={this.onExpoetExcel}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_2_1">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>
                </div>
            </Spin>
        );
    }
}

export default index;




// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-1/index.js